import { NavLink } from "../components/NavLink";

import React from "react";
import Cartoons from '../components/Cartoons';
import { css, compose } from "glamor";

const navBar = css({
  fontSize:'150%',
})


export default ({ pathContext }) => {

  const { group, index, first, last, pageCount, additionalContext:{totalCount}} = pathContext;
  const previousUrl = index - 1 == 1 ? "" : (index - 1).toString();
  const nextUrl = (index + 1).toString();

  return (
    <div>
      <h4>{totalCount} Posts </h4>
      <Cartoons cartoons={group} />
      {pageCount > 1 &&
        <div {...css(navBar)} className="previousLink">
          <NavLink test={first} url={previousUrl}>&laquo;&nbsp;&nbsp;Prev</NavLink>
          {index}/{pageCount}
          <NavLink test={last} url={nextUrl}>Next&nbsp;&nbsp;&raquo;</NavLink>
        </div>
      }


    </div>)
}



// WEBPACK FOOTER //
// ./src/templates/cartoons.js